import type {
  VideoRef,
  ReactVideoSource,
  OnLoadData,
  OnProgressData,
  SelectedVideoTrack,
} from 'react-native-video';

import { SelectedVideoTrackType } from './types/selectedVideoTrackType';

import { Video } from './Video/Video';

export {
  VideoRef,
  ReactVideoSource,
  OnLoadData,
  OnProgressData,
  SelectedVideoTrack,
  SelectedVideoTrackType,
  Video,
};
